import { render, staticRenderFns } from "./LeaderboardSlide.vue?vue&type=template&id=6fb4cd6e&scoped=true&"
import script from "./LeaderboardSlide.vue?vue&type=script&lang=js&"
export * from "./LeaderboardSlide.vue?vue&type=script&lang=js&"
import style0 from "./LeaderboardSlide.vue?vue&type=style&index=0&id=6fb4cd6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb4cd6e",
  null
  
)

export default component.exports